import axios from 'axios'
import dayjs from 'dayjs'

//TODO move all to environment including path
var apiconnect = process.env.VUE_APP_APICONNECT
//"99j3kxamvbpch4mwq76mrxye"
//process.env.VUE_APP_IACCESSTOKEN1
//process.env.VUE_APP_APICONNECT

var apidir_iaccesslogin = apiconnect + "iaccess/um/";
var apidir_iaccessverify = apiconnect + "iaccess/um/loginsecurityinfo";
var tokenkey_iaccess  = process.env.VUE_APP_IACCESSTOKEN

var tokenkey_logger = process.env.VUE_APP_LOGGER

var tempApikey = process.env.VUE_APP_TEMP
//VUE_APP_TEMP'99j3kxamvbpch4mwq76mrxye'
//process.env.VUE_APP_IACCESSTOKEN1
// '99j3kxamvbpch4mwq76mrxye'
 //process.env.VUE_APP_IACCESSTOKEN1
 //'7wjvynebhw7x4pqucfw936pp'
//process.env.VUE_APP_IACCESSTOKEN;


var LogOutUrl = process.env.VUE_APP_IAKAUN_URL
const getDefaultState = () => {
    return {
        UserName: "",
        UserStatusId: "",
        StatusCode: "",
        StatusName: "",
        SecurityPhrase: "",
        SecurityIconDocumentId: "",
        IsSuccessful: false,
        Message: "",
        Token: "",
        NRIC: "",
        IsLockedOut: "",
        Session: "",
        RouteToPath: "",
        incomingAppID:'',
        UserIC:'',
        LanguageToLoad:'',
        TransactionData:'',
        AkamaiToken: '', // to handle APIM token
    }
}

const state = getDefaultState()

const actions = { 
    // Login Details
    GetLoginDetails({commit,state},  loginID) {        
/*         var loginapipath = apidir_iaccessverify + '?username=' + loginID;
           return axios({
            method: "get",
            url: loginapipath,
            headers: {
              Authorization: "Bearer " + tokenkey_iaccess
            }
          })
          .then(function (response) { */
            //console.log(response)
            var str = "{'UserName': '"+loginID+"','UserStatusId': '1','StatusCode': 'A','StatusName': 'Active','isSuccessful': true,'Message': ''}";
            

            state.UserName = loginID,
            //loginID,
            state.UserStatusId = "1",
            state.StatusCode = login.StatusCode,
            state.StatusName = "Active",
            state.IsSuccessful = true,
            state.Message = ""

            return true
           /*  if(response.data.isSuccessful){ */
            /* }else{
              commit('SetLoginFail', str); 
            } 
            return response.data.isSuccessful;*/
        /*   })
          .catch(error => {
            commit('SetLoginFail', error)
            return error
          }) */
    },

    GetLoginId({commit}, id, idType){
        if (idType=="")
        var loginapipath = apidir_iaccesslogin + loginID.user +'/auth?password=' + loginData.password;
        this.$httpClient({
            method: "get",
            url: loginapipath,
            // headers: {
            //   Authorization: "Bearer " + tokenkey_iaccess
            // }
          })
          .then(async function (response) {
            if(response.data.UserStatusId == 1) {
              commit('SetLoginDetails', response.data)
            }else{
              commit('SetLoginFail', response.data);
            }  
          })
          .catch(error => {
            commit('SetLoginFail', error)
          })
    },

    PostTAC() {

    },
    async AuthLogin({commit,state,dispatch}, logindetails) {  

     // var loginapipath = apiconnect + 'auth/login'
       return this.$httpClient({
          method: "post",
          url:  apiconnect + 'iaccess/auth/login?api_key='+tempApikey,
          data :{
            "username": logindetails.username,
            "password": logindetails.password,
            "issuer":"EMIS",
            "appId": 2
          }
        })
        .then(function (response) {
         if(response.data.success === true)  {
   
            commit('ResetToken')
            var _tempToken = (Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
            var _session =  dayjs().add(3600, 'seconds');

            commit('SetToken', _tempToken)
            commit('SetSession', _session)

            state.Token = response.data.token
            state.UserName = logindetails.username
            state.UserStatusId = response.data.success
            state.Message  = response.data.success
            return response.data.success;
          } else{
            state.UserStatusId = response.data.success,
            state.IsSuccessful =response.data.success,
            state.Message = response.data.Message
            return response.data.success;
          }
      })     
      .catch(error => {

      var payload = "Method:  AuthLogin -> " + error.toString()
        dispatch('LoginLogger',{
            typeid:'3',
            appid:'2',
            str:payload
        }) 

         state.UserStatusId = false,
        state.IsSuccessful =false
        if(error.message === "Request failed with status code 401"){
          
          state.Message = 'Authentication failure. Please try again'
        }else{
          state.Message = error.message
        }
        //'Authentication failure. Please try again'
       // commit('SetLoginFail', error)
        return false 
      })
  },
 async AuthToken({commit,state,dispatch,rootState}) { 
     return this.$httpClient({
        method: "post",
        url: apiconnect + 'iaccess/auth/validate?api_key='+tempApikey,
      /*   headers: {
          Authorization: "Bearer " + tokenkey_iaccess
        }, */
        data :{
          "token" : state.Token
        }
      })
      .then(function (response) {
        if(state.UserName === response.data.sub ) {
          if(response.data.profile.CustomerID!=undefined){
            //state.LoginToken = response.data.
            state.UserIC = response.data.profile.CustomerID
            state.UserStatusId = true
            localStorage.clear();
            localStorage.setItem('Creation_uuid',response.data.user.UserID);
//check profile first, then get from user -->CustomerID
            return true;
          }else{
            state.Token=''
            state.UserStatusId = false,
            state.IsSuccessful =false,
            state.Message = 'Authentication failure. Please try again'
            return false
          }
        } else{
          state.Token=''
          state.UserStatusId = false,
          state.IsSuccessful =false,
          state.Message = response.data.message
          // 'Authentication failure. Please try again'
          return false
        }
    })     
    .catch(error => {
    var payload = "Method:  AuthToken -> " + error.toString()
       dispatch('LoginLogger',{
          typeid:'3',
          appid:'2',
          str:payload
      }) 
      console.log(error)
      state.UserStatusId = false,
      state.IsSuccessful =false
      if(error.message === "Request failed with status code 401"){
          
        state.Message = 'Authentication failure. Please try again'
      }else{
        state.Message = error.message
      }
     // commit('SetLoginFail', error)
      return false
    })
  },
  async GetApiToken({commit,state,rootState,dispatch}) {
   
    return this.$httpClient({
        method: "post",
        url: apiconnect + 'oauth/acquire-token?api_key='+tempApikey,
        /*  headers: {
          Authorization: "Bearer " + tokenkey_iaccess
        }, */
        data :{
          //"appId": "EMIS",
          "appId": 2,
          "idToken" : state.Token
        }
      })
      .then(function (response) {
        console.log(response)

        if(response.data.length>0){
          for(var i=0; i<response.data.length; i++){
            
            if(response.data[i].api_name === 'FundAPI'){
              rootState.API.FundAPIToken = response.data[i].access_token 
            }
            if(response.data[i].api_name === 'OnboardingAPI'){
              rootState.API.OnboardingAPIToken = response.data[i].access_token 
            }
            if(response.data[i].api_name === 'TransactionAPI'){
              rootState.API.TransactionAPIToken = response.data[i].access_token 
            }
            if(response.data[i].api_name === 'OnelookAPI'){
              rootState.API.OnelookAPIToken = response.data[i].access_token 
            }
            if(response.data[i].api_name === 'IAccessAPI'){
              rootState.API.IAccessAPIToken = response.data[i].access_token 
            }
            if(response.data[i].api_name === 'LoggerAPI'){
              rootState.API.LoggerAPIToken = response.data[i].access_token 
            }
            if(response.data[i].api_name === 'NotificationAPI'){
              rootState.API.NotificationAPIToken = response.data[i].access_token 
            }
            if(response.data[i].api_name === 'CIFAPI'){
              rootState.API.CIFAPIToken = response.data[i].access_token 
            }
            if(response.data[i].api_name === 'EmisAPI'){
              rootState.API.EmisAPIToken = response.data[i].access_token 
            }
            if(response.data[i].api_name === 'AgentAPI'){
              rootState.API.AgentAPIToken = response.data[i].access_token 
            }
            
          }
          state.UserStatusId = true
        }else{
          state.Token=''
          state.UserStatusId = false,
          state.IsSuccessful =false,
          state.Message = 'Authentication failure. Please try again'
        }
    })    
    .catch(error => {
      var payload = "Method:  GetApiToken -> " + error.toString()
     dispatch('LoginLogger',{
          typeid:'3',
          appid:'2',
          str:payload
      }) 
      state.UserStatusId = false,
      state.IsSuccessful =false
      if(error.message === "Request failed with status code 401"){
          
        state.Message = 'Authentication failure. Please try again'
      }else{
        state.Message = error.message
      }
      return false
    })
  },

  async LoginLogger({state, rootState,dispatch},Obj){
    var typeid  = Obj.typeid
    var appid  = Obj.appid
    var str = Obj.str

    //console.log("typeid ->" + typeid)
   // console.log("appid ->" + appid)
   // console.log("str ->" + str)
    return this.$httpClient({
        method: "post",
        url: apiconnect + 'logger/apploginternal' ,
        // headers: { Authorization: "Bearer " + tokenkey_logger },
        //process.env.VUE_APP_LOGGER
        data : {
            "request_typeid": typeid,
            "request_appid": appid,
            "request_payload": str
         }
    })
    .then(function (response) {
        
      //  console.log('Loggging API -> '+ response)
      //  console.log(url)
        /* console.log(response.data.StatusCode)

        if(response.data.StatusCode == "200"){
           // rootState.CD.FormDetails.ApplicationId = response.data.ApplicationId
            return true
        }
        else{

            return response.data.Message
        } */
    })
    .catch(function (error){
     //   console.log(error);
        return false
    });

},
  
  
  /* 

    AuthLogin({commit,state}, logindetails) {

      
        var loginapipath = apidir_iaccesslogin +  logindetails.username + '/auth?password=' + logindetails.password;
        //console.log(loginapipath)
        return axios({
            method: "get",
            url: loginapipath,
            headers: {
              Authorization: "Bearer " + tokenkey_iaccess
            }
          })
          .then(function (response) {
         //   console.log(response)
            if (response.data.Status == 1) {
              var _tempToken = (Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
              var _session =  dayjs().add(3600, 'seconds');
              commit('ResetToken')
              commit('SetToken', _tempToken)
              commit('SetLoginAuth', response.data)  
              commit('SetSession', _session)
              return response.data.Status;
            } else{
              state.UserStatusId = response.data.Status,
              state.IsSuccessful = response.data.Status,
              state.Message = response.data.Message
              return response.data.Status;
            }
        })     
        .catch(error => {
          commit('SetLoginFail', error)
          return error
        })
    }, */

    /*async AuthForgetPassword({commit}, newPassword) {

    },*/

    AuthStatus({commit}, password) {
        var loginapipath = apidir_iaccesslogin + '/status?password=' + password;
        axios({
            method: "get",
            url: loginapipath,
            headers: {
              Authorization: "Bearer " + tokenkey_iaccess
            }
          }).then(async function (response) {

            if (response.StatusCode == 200) {
              var _tempToken = (Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
              commit('ResetToken')
              commit('SetToken', _tempToken)
              commit('SetLoginAuth', response.data)  
            } 
        })
    },
    CheckSession({commit, getters} ){
      var _session = getters.IsSessionExpired

   //   console.log(_session)
      if (! _session) {
        _session = dayjs() 
      }

      //console.log(dayjs().isBefore(_session))
      if (dayjs().isBefore(_session) ) 
      {
        commit('ResetState_LoginDetails')
        commit('ResetToken')
        return true
      } else {
        return false
      }
    },
    triggerLogout({commit, getters} ){
      commit('ResetState_LoginDetails')
      commit('ResetToken')

      window.location.href = LogOutUrl;
      //'https://iakaunuat2.epf.gov.my/member/member/login'
    }
}

const mutations = {
    ResetState_LoginDetails(state) {
        Object.assign(state, getDefaultState());
    },
    createCookie(state,Obj){
      var name = Obj.CookieName
      var value = Obj.CookieValue
      var minutes = Obj.CookieTime

      if (minutes) {
        var date = new Date();
        date.setTime(date.getTime()+(minutes*60*1000));
        var expires = "; expires="+date.toGMTString();
      } else {
          var expires = "";
      }
      document.cookie = name+"="+value+expires+"; path=/";
    },
    getCache(state,Obj){

      var name = Obj.cacheName + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    SetLoginDetails(state, login){
  // console.log(login)
        state.UserName = login.UserName,
        state.UserStatusId = login.UserStatusId,
        state.StatusCode = login.StatusCode,
        state.StatusName = login.StatusName,
        state.SecurityPhrase = login.SecurityPhrase,
        state.SecurityIconDocumentId = login.SecurityIconDocumentId,
        state.IsSuccessful = login.isSuccessful,
        state.Message = login.Message

    },
    SetLoginAuth(state, login){
        state.Message = login.Message,
        state.UserIC = login.CustomerInfo.CustomerID,

        //state.IsLockedOut = login.MembershipInfo.IsLockedOut,
        state.UserStatusId = login.Status
        //state.StatusName = login.UserStatus
    },
    
    SetLoginStatus(state, login){
        state.Message = login.Message,
        state.IsLockedOut = login.MembershipInfo.IsLockedOut,
        state.UserStatusId = login.Status,
        state.StatusName = login.UserStatus
    },
    SetToken(state, token){
        state.Token = token
    },
    SetSession(state, session){
      //alert(state.Session)
      state.Session = session
    },
    ResetToken(state){
        state.Token = "",
        state.Session = "",
        //state.UserName = "",
        state.UserStatusId = "",
        state.StatusCode = ""

    },
    SetLoginFail(state, fail) {
        state.IsSuccessful = fail.isSuccessful,
        state.Message = fail.Message
    },
    SetPath(state, path) {
      state.RouteToPath = path
    },
    ResetPath(state) {
      state.RouteToPath = ""
    }
}

const getters = {
    IsIdFound: state => !!state.UserStatusId,
    IsLockedOut: state => state.IsLockedOut,
    IsSuccessful: state => state.IsSuccessful,
    IsSessionExpired: state => state.Session,
    GetRoutePath: state => state.RouteToPath
}

export default {
    state,
    actions,
    mutations,
    getters
}
